import EdoVC from './EdoVC';

export default EdoVC;
